<template>
  <div
    class="flatGalleryImg flat-gallery-img"
    :class="[row_count ? 'row m-md--15' : '', { 'athena-flat-img': theme == 'athena' }]"
  >
    <div
      :class="[row_count ? `col-${12 / row_count} p-md-15` : '']"
      :style="theme == 'vogue' ? 'margin-bottom: 30px' : ''"
      v-for="(item, index) in flatGallery" :key="'flatgallery' + item.ID"
    >
      <div class="flat-gallery-img__media">
        <template v-if="tagShowFirst ? index === 0 : true">
          <v-product-tag
            v-if="is_product && productTagData"
            :productTag="productTagData"
            :productInfo="productInfo"
          ></v-product-tag>
        </template>

        <!-- 用户上传视频 -->
        <template v-if="item.media_content_type === 'video'">
          <v-video-player
            :poster="item.thumbnail"
            :video-src="item.url"
            :src="item.url"
            :muted="true"
            :show-play-button="true"
            :autoplay="false"
          />
        </template>

        <!-- youtube视频 -->
        <template v-else-if="item.media_content_type === 'external_video'">
          <div class="flat-gallery-img__iframe-wrapper">
            <iframe
              class="flat-gallery-img__iframe"
              :src="item.url"
              :video-src="item.url"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            >
            </iframe>
          </div>
        </template>

        <template v-else>
          <!-- 放大镜 -->
          <template v-if="pic_zoom">
            <v-picZoom class="flat-gallery-img__pic-zoom" :appendToBody="false" :thumbnail="item.thumbnail" :url="item.url" :bigUrl="item.url"></v-picZoom>
          </template>
          <v-lazy-img v-else :data-url="item.url" :src="item.thumbnail"  width="100%"></v-lazy-img>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import VideoPlayer from '@/js/components/VideoPlayer.vue'
import vProductTag from '@/js/components/view/productTag/productTag.vue'
import vPicZoom from '@/js/components/common/picZoom.vue'

export default {
  components: {
    [VideoPlayer.name]: VideoPlayer,
    vProductTag,
    vPicZoom
  },
  props: ['gallery', 'pic_zoom', 'row_count', 'product_res', 'is_product', 'theme', 'productInfo', 'tagShowFirst'],
  data() {
    return {
      // defaultImage,
      flatGallery: [],
    }
  },
  beforeMount() {
    this.flatGallery = this.gallery
  },
  computed: {
    productTagData() {
      return this.$store.state?.product_tag_list?.[this.product_res?.ID]
    },
  },
  watch: {
    '$store.state.feature_image_id'(newV) {
      this.flatGallery.some((flatitem, flatindex) => {
        if (flatitem.ID == newV) {
          this.flatGallery.unshift(this.flatGallery.splice(flatindex, 1)[0])
        }
      })
    },
  },
}
</script>
<style scoped lang='scss'>
.flat-gallery-img {
  max-width: 100vw;
  &__media {
    position: relative;
  }
  &__iframe-wrapper {
    width: 100%;
    max-width: 100vw;
    height: 0;
    padding-bottom: 80%;
    position: relative;
  }
  &__iframe {
    position: absolute;
    height: 100%;
    width: 100%;
    z-index: 1;
    top: 0;
    left: 0;
  }
  &__pic-zoom {
    display: block;
    ::v-deep {
      .mirror {
        &__truth {
          display: block;
        }
      }
      .wrap {
        display: block;
      }
    }
  }
}
.flatGalleryImg {
  padding: 0 40px;
  text-align: center;
  margin-bottom: 50px;
}
.athena-flat-img {
  & > div {
    &::v-deep .mirror {
      width: 100%;
      width: 100%;
      .wrap,
      .wrap > div {
        width: 100% !important;
        width: 100% !important;
      }
    }
  }
}
</style>
